import { FertiliserAppUnit, INutritionPlanProductApp, INutritionProductApp } from "../types"

const solidUnits = [
    { unit: FertiliserAppUnit.Kg, text: "kg" },
    { unit: FertiliserAppUnit.T, text: "t" }
]

const liquidUnits = [
    { unit: FertiliserAppUnit.L, text: "l" },
    { unit: FertiliserAppUnit.M3, text: "m³" }
]


export function getProductUnits(app: INutritionProductApp) {
    if (!app) return undefined
    return app.isLiquid() ? liquidUnits : solidUnits
}

export function getProductUnitsText(app: INutritionProductApp, unit: FertiliserAppUnit): string {

    if (!app) return ""

    const u = (app.isLiquid() ? liquidUnits : solidUnits).find(u => u.unit == unit)

    return u ? u.text + "/ha" : ""

}

export function getProductUnitsTextNormalized(app: INutritionProductApp, nutrient?: boolean): string {

    if (app) {
        const liquid = app.isLiquid() && (!nutrient)
        const tonnes = app.isManure() && (!nutrient)
        return getUnitTextNormalized(liquid, tonnes)
    }

    return ""

}


export function getProductUnitsTextNormalizedFromApplication(app: INutritionPlanProductApp, nutrient?: boolean) {

    if (app) {

        let liquid = false
        let tonnes = false

        const fert = app.Fertiliser
        const fertstd = fert ? fert.StandardProduct : null

        if (fert) {
            liquid = !!((fert.Custom ? fert.Liquid : null) || (fertstd ? fertstd.Liquid : false))
            tonnes = false
        }

        const manure = app.Manure
        if (manure) {
            liquid = manure.ManureType.Liquid
            tonnes = true
        }


        liquid = (!nutrient) && liquid
        tonnes = (!nutrient) && tonnes

        return getUnitTextNormalized(liquid, tonnes)

    }

    return ""
}

export function getUnitTextNormalized(liquid: boolean, tonnes: boolean) {

    if (liquid) {
        return liquidUnits.find(u => u.unit === (tonnes ? FertiliserAppUnit.M3 : FertiliserAppUnit.L)).text;
    }
    else {
        return solidUnits.find(u => u.unit === (tonnes ? FertiliserAppUnit.T : FertiliserAppUnit.Kg)).text;
    }

}

export function getRoundedValueForUnit(value: number, unit: FertiliserAppUnit) {

    if (unit === FertiliserAppUnit.Kg || unit === FertiliserAppUnit.L) {
        // 0 digit
        return Math.round(value)
    }
    if (unit === FertiliserAppUnit.T || unit === FertiliserAppUnit.M3) {
        // 1 digit
        return Math.round(value * 10) / 10
    }
    return value
}
